import { render, staticRenderFns } from "./NewNotice.vue?vue&type=template&id=4611fd42&"
import script from "./NewNotice.vue?vue&type=script&lang=js&"
export * from "./NewNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports